var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({attrs:{"type":_vm.$attrs.type ? _vm.$attrs.type : 'primary'},on:{"click":_vm.handleExport}},'el-button',_vm.$attrs,false),[_vm._v(_vm._s(_vm.btnText))])}
var staticRenderFns = []

export { render, staticRenderFns }